import axios from "axios";

let activeRequests: number = 0;
let slowTimer: any = null;

// Dispatchers
const triggerStart = () => window.dispatchEvent(new Event("slow-response-start"));

const startSlowTimer = () => {
  slowTimer = setTimeout(() => {
    if (activeRequests > 0) {
      triggerStart();
    }
  }, 90000); // 60000 = 1 minute 
};

const clearSlowTimer = () => {
  clearTimeout(slowTimer);
  slowTimer = null;
};

// REQUEST INTERCEPTOR
axios.interceptors.request.use((config) => {
  activeRequests++;

  // If this is the first request, start the slow timer
  if (activeRequests === 1) {
    startSlowTimer();
  }

  return config;
});

// RESPONSE INTERCEPTOR
axios.interceptors.response.use(
  (response) => {
    activeRequests--;

    if (activeRequests === 0) {
      clearSlowTimer();
    }

    return response;
  },
  (error) => {
    activeRequests--;

    if (activeRequests === 0) {
      clearSlowTimer();
    }

    return Promise.reject(error);
  }
);
